"use client";

import * as React from "react";
import { X } from "lucide-react";
import { cn } from "../primitives/cn";

/** Account-level persistent warning/error. Visual: amber/red semantic. */
export function SystemBanner({
  tone = "warning",
  children,
  onDismiss,
}: {
  tone?: "warning" | "error";
  children: React.ReactNode;
  onDismiss?: () => void;
}) {
  return (
    <div
      role="status"
      className={cn(
        "flex items-start gap-3 border-b px-4 py-3 text-sm",
        tone === "warning" &&
          "border-[hsl(var(--warning))]/30 bg-[color-mix(in_srgb,hsl(var(--warning))_12%,transparent)] text-[hsl(var(--warning))]",
        tone === "error" &&
          "border-destructive/30 bg-[color-mix(in_srgb,hsl(var(--destructive))_12%,transparent)] text-destructive",
      )}
    >
      <div className="flex-1">{children}</div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="rounded p-1 hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Dismiss"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>
  );
}

/** Product announcement — neutral colors (distinct from SystemBanner). */
export function AnnouncementBanner({
  children,
  onDismiss,
}: {
  children: React.ReactNode;
  onDismiss?: () => void;
}) {
  return (
    <div
      role="status"
      className="flex items-start gap-3 border-b border-border bg-muted px-4 py-3 text-sm text-foreground"
    >
      <div className="flex-1">{children}</div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="rounded p-1 hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Dismiss"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
